import request from "./index";

export const ClientChat = {
  // transfer
  GetTransferSkills: () => {
    return request.post("/api/ClientChat/GetTransferSkills");
  },
  GetGSMInfo: (data) => {
    return request.post("/api/ClientChat/GetGSMInfo", data);
  },
  GetLinkPreview: (data) => {
    return request.post("/api/ClientChat/GetLinkPreview", data);
  },
  DownloadUploadFile: (data, config) => {
    return request.post("/api/ClientChat/DownloadUploadFile", data, config);
  },
  UploadRecoredFiles: (data) => {
    return request.post("/api/ClientChat/UploadRecoredFiles", data);
  },
  UploadTempFiles: (data) => {
    return request.post("/api/ClientChat/UploadTempFiles", data);
  },
  WebRiskLookup: (data) => {
    return request.post("/api/ClientChat/WebRiskLookup", data);
  },
  AgentIdleTrigger: (data) => {
    return request.post("/api/ClientChat/AgentIdleTrigger", data);
  },
};
export const ClientChatMessage = {
  uploadImage: (data) => {
    return request.post("/api/ClientChatMessage/UploadImage", data);
  },
};
